import { render } from "./Cocomoni.vue?vue&type=template&id=9127819c&scoped=true"
import script from "./Cocomoni.vue?vue&type=script&lang=js"
export * from "./Cocomoni.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Cocomoni.vue?vue&type=style&index=0&id=9127819c&lang=scss&module=true"
cssModules["$style"] = style0
import "./Cocomoni.vue?vue&type=style&index=1&id=9127819c&lang=scss&scoped=true"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-9127819c"]])

export default __exports__